import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-building-details-section',
  templateUrl: './details-section.component.html',
  styleUrls: ['./details-section.component.scss'],
})
export class DetailsSectionComponent {
  @Input() floors: any;

  constructor() {}
}
